.loader {
  display: block;
  margin: 0 auto 1rem;
  max-width: 100%;
}

.wave {
  animation: wave 1.6s linear infinite;
}

/* One period of the wave, so the loop has no seam. */
@keyframes wave {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-80px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .wave {
    animation: none;
  }
}
